import { GRAMMAR_ITEM_TYPES } from '@repo/config';
import { z } from 'zod';

const englishIqChoiceSchema = z.object({
  id: z.string(),
  text: z.string(),
});

const englishIqItemBaseShape = {
  choices: z.array(englishIqChoiceSchema),
  difficulty: z.number(),
  family: z.string(),
  id: z.string(),
  mediaUrl: z.string().optional(),
  prompt: z.string(),
};

export const englishIqItemSchema = z.discriminatedUnion('type', [
  z.object({
    ...englishIqItemBaseShape,
    content: z.never().optional(),
    skill: z.enum(['meaning', 'listening']),
    type: z.literal('choice'),
  }),
  z.object({
    ...englishIqItemBaseShape,
    content: z.object({ question: z.string() }),
    skill: z.literal('grammar'),
    type: z.literal(GRAMMAR_ITEM_TYPES[0]),
  }),
  z.object({
    ...englishIqItemBaseShape,
    content: z.object({ sentence: z.string() }),
    skill: z.literal('grammar'),
    type: z.literal(GRAMMAR_ITEM_TYPES[1]),
  }),
  z.object({
    ...englishIqItemBaseShape,
    choices: z.array(englishIqChoiceSchema).max(0),
    content: z.object({ tokens: z.array(z.string()) }),
    skill: z.literal('grammar'),
    type: z.literal(GRAMMAR_ITEM_TYPES[2]),
  }),
  z.object({
    ...englishIqItemBaseShape,
    choices: z.array(englishIqChoiceSchema).max(0),
    content: z.object({
      errorSpan: z.string(),
      sentence: z.string(),
    }),
    skill: z.literal('grammar'),
    type: z.literal(GRAMMAR_ITEM_TYPES[3]),
  }),
]);

export type IEnglishIqItem = z.infer<typeof englishIqItemSchema>;
